import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=b5c4aee2&scoped=true&"
import script from "./ProjectCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreate.vue?vue&type=style&index=0&id=b5c4aee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c4aee2",
  null
  
)

export default component.exports